import React from 'react';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { PersonProfileImageSmallInfoCard } from '../../../components/molecules/PersonProfileImageSmall';
import { TextMarker } from '../TextMarker/TextMarker';
import { ProfilePictureModifier } from './ProfilePictureName.modifier';
import IUrl, { ISonURL } from '../../../types/IUrl';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { Strong } from '../../../components/atoms/Strong/Strong';

type ProfilePictureName = {
  profileLink: ISonURL;
  profileName: string;

  profileImageUrl?: ProfileImageSmall;
  personInfoCardUrl?: IUrl;
  highlight?: boolean;
  modifier?: Modifier<ProfilePictureModifier>;
  editorialResponsible?: string;
};

/**
 * This component generates a users small **profile image** together with the the **linked user name (bold text)**.
 * Options:
 *   - you can enable the PersonInfoCard on the profile image
 *   - highlighting can be activated (only for SearchLists!)
 * */
export function ProfilePictureName({
  profileLink,
  profileName,
  profileImageUrl,
  highlight,
  personInfoCardUrl,
  modifier,
  editorialResponsible,
}: ProfilePictureName) {
  return (
    <div className={extendClassNameWithModifier('profile-picture-name', modifier)}>
      {personInfoCardUrl && profileImageUrl && (
        <PersonProfileImageSmallInfoCard
          profileImageUrl={profileImageUrl}
          personInfoCardUrl={personInfoCardUrl}
          profileName={profileName}
        />
      )}
      <div className="profile-picture-name__link-container">
        {profileLink.url !== undefined
          ? (
              <Hyperlink to={profileLink.url} className="profile-picture-name__link font-regular-15-21">
                <Strong>{highlight ? <TextMarker text={profileLink.name} /> : profileLink.name}</Strong>
              </Hyperlink>
            )
          : (
              <p>{profileName}</p>
            )}
        {editorialResponsible // hidden from screen readers because info is in meta-info dl
          ? (<span aria-hidden="true">{' '}({editorialResponsible})</span>)
          : null }
      </div>
    </div>
  );
}
